import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <main className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 pt-[68px] md:pt-[74px] bg-background-50 overflow-hidden">
        <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-heading text-[9rem] md:text-[15rem] text-background-200 select-none pointer-events-none">
          404
        </span>
        <div className="relative z-10 max-w-lg">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary-500/40 text-[11px] tracking-[0.24em] text-primary-500">
            <i className="ri-file-unknow-line"></i>
            ARCHIVE NOT FOUND
          </span>
          <h1 className="mt-6 font-heading text-2xl md:text-3xl text-foreground-950">
            这条线索没有对应的档案
          </h1>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
            你要找的页面可能已经被合并、更名，或者从未存在过。
            可以回到档案库，从专题索引里重新翻一翻。
          </p>
          <p className="mt-3 text-xs font-mono text-foreground-500">{location.pathname}</p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/archive"
              className="px-6 py-3 rounded-md border border-background-300 text-foreground-900 text-sm hover:border-primary-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              进入档案库
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}